import type * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type * as dms from '../../dms'

import { DEPARTMENT_ENTITY_ID, DIVISION_ENTITY_ID } from './constants'
import type { Feature } from './feature'
import { Name } from './name'
import type { TypeParams } from './types'

/**
 * Selectors for the Organizations registry feature
 */
export class Selectors {
  /**
   * Returns the dynamic Organization EC for one Organization Entity
   */
  public readonly getOrganizationEc
  /**
   * Returns the dynamic Organization EC for all Organization Entities
   */
  public readonly getAllOrganizationEc

  /**
   * Returns the dynamic Organization EC for the parent Organization of a given
   * entity
   */
  public readonly getParentEc

  /**
   * Core Department Organization EC accessor
   */
  public readonly departmentEc

  /** Core Division Organization EC accessor */
  public readonly divisionEc

  /** All Department Organization EC accessor */
  public readonly allDepartmentEc

  /** All Division Organization EC accessor */
  public readonly allDivisionEc

  constructor(feature: Feature, schemaFeature: dms.schema.Feature) {
    this.getOrganizationEc = feature.createSelectorMethod(
      (entityId: ents.core.dms.models.Entity.Id) => () =>
        ec.Collection.instances.tryGet<TypeParams>(Name.from(entityId))
          .collection,
    )
    this.getAllOrganizationEc = feature.createSelectorMethod(
      (entityId: ents.core.dms.models.Entity.Id) => () =>
        ec.Collection.instances.tryGet<TypeParams>(Name.All.from(entityId))
          .collection,
    )

    this.getParentEc = feature.createSelectorMethod(
      (entityId: ents.core.dms.models.Entity.Id) =>
        schemaFeature.selectors.schema.project(schema => {
          const parent = schema.tryGetParentEntityOf(entityId)
          return parent
            ? ec.Collection.instances.tryGet<TypeParams>(Name.from(parent.id))
                .collection
            : undefined
        }),
    )

    this.departmentEc = this.getOrganizationEc(DEPARTMENT_ENTITY_ID)
    this.divisionEc = this.getOrganizationEc(DIVISION_ENTITY_ID)
    this.allDepartmentEc = this.getAllOrganizationEc(DEPARTMENT_ENTITY_ID)
    this.allDivisionEc = this.getAllOrganizationEc(DIVISION_ENTITY_ID)
  }
}
